










































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Emit, Vue, Ref, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import SolicitacaoStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoStore'
import ContestacaoMedicaStore from '@/components/ContestacaoMedica/Store/ContestacaoMedicaStore'
import SolicitacaoCirurgiaStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoCirurgiaStore'
import SolicitacaoPendenciaStore from '@/components/SolicitacaoPendencia/Store/SolicitacaoPendenciaStore'
import BackofficeFidelizacaoStore from '@/components/Backoffice/Store/BackofficeFidelizacaoStore'
import SolicitacaoCancelamentoStore from '@/components/SolicitacaoCancelamento/Store/SolicitacaoCancelamentoStore'
import ChatStore from '@/components/Chat/Store/ChatStore'
import { TipoEnvioMensagemEnum, TipoUsuarioEnum, Snackbar, CancelarSolicitacaoParam, TipoOrigemEnum, SituacaoEnum, TipoDocumentoUpload, StatusOption, StatusCirurgiaEnum } from '@/types/_'
import Theme from '@/styles/Theme'
import EventBus from '@/plugins/EventBus'
import { maskDate, timeout, createPDFWithMultiplePagesGeneration, maskMoney } from '@/utils/common'
import { AgendamentoMedico, Situacao, Solicitacao } from '@/types/interfaces/Solicitacao'
import SolicitacaoCirurgiaApi from '@/Apis/Agendamento/Services/SolicitacaoCirurgiaApi'
import AprovacaoMedicaApi from '@/Apis/Agendamento/Services/AprovacaoMedicaApi'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import GuiaTissOpme from '@/template/backoffice/GuiaTissOpme.vue'
import GuiaTissInternacao from '@/template/backoffice/GuiaTissInternacao.vue'
import { permissionService } from '@/services/permission.service'
import EcgIcon from '@/utils/ecg-icon.vue'
import HistoricoSolicitacaoStore from '../HistoricoSolicitacao/Store/HistoricoSolicitacaoStore'
import ChatAgendamentoStore from '../chat-agendamento/store/chat-agendamento-store'
import SolicitacaoClinicaStore from './store/SolicitacaoClinicaStore'
import ChatAgendamentoPendenciaStore from '../chat-agendamento-pendencia/store/chat-agendamento-pendencia-store'
import AvaliacaoRiscoApaStore from '../AvaliacaoRiscoApa/Store/AvaliacaoRiscoApaStore'

@Component({
  components: {
    GuiaTissOpme,
    GuiaTissInternacao,
    EcgIcon,
  },
})
export default class ComponentModalSolicitacaoCirurgiaGerenciar extends Vue {
  $refs!: {
    nomeCirurgia: any,
    guiaTissInternacao: any,
    guiaTissOpme: any,
  }

  loadClose: boolean = false
  loadCirurgiaRealizada: boolean = false
  tmpDialog: boolean = false
  modalApproval: boolean = false
  modalAprovarOrcamento: boolean = false
  numeroDeCelular: number = 5511945120820
  mensagemDeTexto: string = 'Olá, gostaria de saber qual é a sua necessidade específica para a cirurgia que será realizada no dia 22/05/2021'
  snackbar: Snackbar = {
    disabled: false,
    disabledBtn: false,
    show: false,
    timeout: 12000,
    message: '',
  }

  clinicaStatuses = [] as StatusOption[]

  nCirurgia: string = ''
  localLoad: boolean = false
  place: string = ''
  confirmarExclusao: boolean = false
  loadDeleteSolicitacao: boolean = false
  aprovacaoObjec: any = {}
  exibirBotaoAprovacao: boolean = true;

  isSurgeryAnnotationModalOpen = false
  loadingSurgeryAnnotations = false
  loadingCriarSolicitacaoOrcamentoParticularAvulso = false

  loadingHistorico = ''
  loadingChat = ''
  isAvaliacaoRiscoApaModalOpen= false
  canShowModalAvaliacaoRiscoApaOpen= false
  loadingAvaliacaoRiscoApa= false

  get loadingDeleteSolicitacao() { return this.loadDeleteSolicitacao }
  set loadingDeleteSolicitacao(value: boolean) { this.loadDeleteSolicitacao = value }

  @Watch('showModalGerenciar')
  async onModalChange(isOpened) {
    if (isOpened && this.podeVisualizarStatus) {
      await this.getHospitalStatuses()
    }
  }

  async situacaoChange(value: Situacao) {
    const { status, init } = this.getSolicitacaoStore.requestMessage
    this.setLoadingRequest(status, init.text)

    const solicitacaoId = this.getSolicitacaoPendenciaStore.agendamentoMedico.id
    const statusSituacao = value.key as SituacaoEnum

    const data = {
      solicitacaoId,
      data: {
        statusSituacao,
      },
    }

    const res = await this.solicitacaoClinicaStore.atualizarStatus(data)
    if (res.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Situação alterada com sucesso.', icon: 'done', color: '#2E7D32' })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: 'Houve um erro ao alterar a situação.', icon: 'warning', color: '#C62828' })
    }

    this.clearLoadingRequest()
    this.ga('agendamento-medico', 'atualizar-status-solicitacao')
  }

  obterAprovadores = (jsonData: any) => {
    const result: { nome: string; statusAprovacao: string; justificativa?: string }[] = []

    if (jsonData.states && Array.isArray(jsonData.states)) {
      jsonData.states.forEach((state: any) => {
        if (state.aprovadores && Array.isArray(state.aprovadores)) {
          state.aprovadores.forEach((aprovador: any) => {
            result.push({
              nome: aprovador.nome,
              statusAprovacao: aprovador.statusAprovacao,
              justificativa: aprovador.justificativa,
            })
          })
        }
      })
    }

    return result
  }

  aprovacaoText = (status: string) => {
    switch (status) {
      case 'Aprovada':
        return 'Urgência aprovada pelo hospital.'
      case 'Reprovada':
        return 'Urgência reprovada pelo hospital.'
      case 'Pendente':
        return 'Urgência enviada para análise do hospital.'
      default:
        return status
    }
  }

  async aprovacaoData() {
    try {
      const aprovacaoDataList = [] as any[]

      if (this.getSolicitacaoPendenciaStore.agendamentoMedico.aprovacoesSolicitacao) {
        const requests = this.getSolicitacaoPendenciaStore.agendamentoMedico.aprovacoesSolicitacao.map(async (aprovacao) => {
          const response = await AprovacaoMedicaApi.getAprovacaoMedicoSecretaria(aprovacao.aprovacaoId)
          if (response.data.deveSerExibida) {
            const aprovadores = this.obterAprovadores(response.data.aprovacao)

            aprovacaoDataList.push({
              aprovacaoNome: aprovacao.aprovacaoNome,
              header: {
                criadaEm: response.data.aprovacao.criadaEm,
              },
              aprovadores,
              deveSerExibida: response.data.deveSerExibida,
            })
          } else {
            aprovacaoDataList.push({
              status: response.data.status,
              deveSerExibida: response.data.deveSerExibida,
            })
          }
        })
        await Promise.allSettled(requests)
      }

      this.aprovacaoObjec = aprovacaoDataList
    } catch (error) {
      console.error('Erro ao buscar dados de aprovação:', error)
      this.exibirBotaoAprovacao = false
    }
  }


  async desfazerCancelamento() {
    const { status, init } = this.getSolicitacaoStore.requestMessage
    this.setLoadingRequest(status, init.text)

    const solicitacaoId = this.getSolicitacaoPendenciaStore.agendamentoMedico.id

    const res = await this.solicitacaoClinicaStore.desfazerCancelamento(solicitacaoId)
    if (res.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Cancelamento desfeito com sucesso.', icon: 'done', color: '#2E7D32' })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: 'Houve um erro ao desfazer o cancelamento.', icon: 'warning', color: '#C62828' })
    }

    this.clearLoadingRequest()
    this.ga('agendamento-medico', 'desfazer-cancelamento-da-solicitacao')

    this.closeModalGerenciar()
  }

  get situacao() {
    return this.getSolicitacaoPendenciaStore.agendamentoMedico.situacao
  }

  get podeAlterarOrigemDoPaciente() {
    return this.getSolicitacaoPendenciaStore.agendamentoMedico.acoes.podeAlterarOrigemDoPaciente
  }

  get podeDesfazerCancelamento() {
    return this.getSolicitacaoPendenciaStore.agendamentoMedico.acoes.podeDesfazerCancelamento
  }

  get podeVisualizarModalAtualizarDataAgendamento() {
    return this.getSolicitacaoPendenciaStore.agendamentoMedico.acoes.podeVisualizarModalAtualizarDataAgendamento
  }

  get podeInformarCirurgiaComoRealizada() {
    return this.getSolicitacaoPendenciaStore.agendamentoMedico.acoes.podeInformarCirurgiaComoRealizada
  }

  get podeInformarCirurgiaComoNaoRealizada() {
    return this.getSolicitacaoPendenciaStore.agendamentoMedico.acoes.podeInformarCirurgiaComoNaoRealizada
  }

  get podeVisualizarStatus() {
    return this.getSolicitacaoPendenciaStore.agendamentoMedico.acoes.podeVisualizarStatus
  }

  get podeAtualizarStatus() {
    return this.getSolicitacaoPendenciaStore.agendamentoMedico.acoes.podeAtualizarStatus
  }

  get podeVisualizarAnotacoes() {
    return permissionService.hasPermission('agendamento.medica.anotacoes.visualizar')
  }

  get podeAtualizarDataAgendamento() {
    return this.filterCirurgias !== 'cirurgiasRealizadas'
    && this.getSolicitacaoPendenciaStore.agendamentoMedico.acoes.podeAtualizarDataAgendamento
  }

  get podeAtualizarItensAutorizados() {
    return this.getSolicitacaoPendenciaStore.agendamentoMedico.acoes.podeAtualizarItensAutorizados
    && (this.situacao.key === 'Autorizada' || this.situacao.key === 'AutorizadaParcial' || this.situacao.key === 'AutorizadaAceitaMedico')
  }

  get podeSolicitarCancelamento() {
    return this.getSolicitacaoPendenciaStore.agendamentoMedico.acoes.solicitarCancelamento
  }

  get clinicaFazCancelamentoDaSolicitacao() {
    return this.getSolicitacaoPendenciaStore.agendamentoMedico.acoes.clinicaFazCancelamentoDaSolicitacao
  }

  get medicoCancelaSolicitacao() {
    return this.getSolicitacaoPendenciaStore.agendamentoMedico.acoes.medicoCancelaSolicitacao
  }

  get podeExcluirSolicitacaoDeCirurgia() {
    return this.getSolicitacaoPendenciaStore.agendamentoMedico.acoes.podeExcluirSolicitacaoDeCirurgia
  }

  get podeAssinarEEnviarQuandoDisponivelParaEnvio() {
    return this.getSolicitacaoPendenciaStore.agendamentoMedico.acoes.podeAssinarEEnviarQuandoDisponivelParaEnvio
  }

  get podeAplicarCirurgiaModelo() {
    return this.getSolicitacaoPendenciaStore.agendamentoMedico.acoes.podeAplicarCirurgiaModelo
  }

  get solicitacaoClinicaStore() {
    return getModule(SolicitacaoClinicaStore, this.$store)
  }

  get allowBtnAprovacao() {
    return this.getSolicitacaoPendenciaStore.agendamentoMedico.aprovacoesSolicitacao && this.getSolicitacaoPendenciaStore.agendamentoMedico.aprovacoesSolicitacao.length > 0
  }

  get getAvaliacaoRiscoApaStore() {
    return getModule(AvaliacaoRiscoApaStore, this.$store)
  }

  formatDate(date: string) {
    return maskDate(date)
  }

  async showHistory() {
    const data = this.getSolicitacaoPendenciaStore.agendamentoMedico
    const solicitacaoId = data.id
    this.loadingHistorico = solicitacaoId
    await this.historicoSolicitacaoStore.getHistoricoSolicitacao(solicitacaoId)
    this.loadingHistorico = ''
    this.ga('agendamento-medico', 'ver-historico')
  }

  get canShowMenuAvaliacao() {
    const { agendamentoMedico } = this.getSolicitacaoPendenciaStore
    const { apa, statusCirurgia } = agendamentoMedico || {}

    if (apa && (statusCirurgia === StatusCirurgiaEnum.NaoRealizada || (statusCirurgia === StatusCirurgiaEnum.Realizada && apa.notificacaoEnviada === true))) {
      return true
    }
    return false
  }

  closeModalAvaliacaoRiscoApa() {
    this.isAvaliacaoRiscoApaModalOpen = false
  }

  handlerModalAvaliacaoRiscoApa(isLoading: boolean) {
    this.loadingAvaliacaoRiscoApa = isLoading
  }

  async showModalAvaliacaoPreOperatoriaApa() {
    if (this.canShowMenuAvaliacao) {
      this.isAvaliacaoRiscoApaModalOpen = true
    }
  }

  showChat() {
    const data = this.getSolicitacaoPendenciaStore.agendamentoMedico
    const solicitationId = data.id

    this.loadingChat = solicitationId

    const recipientName = data.hospital
    const senderId = this.$user.profile.sub

    this.chatStore.reset()
    this.chatStore.openChatModal({
      solicitationId,
      recipientName,
      senderId,
      hospitalId: data.hospitalId,
    })

    this.ga('agendamento-medico', 'abrir-chat')

    this.loadingChat = ''
  }

  async getHospitalStatuses() {
    try {
      const APIResponse = await SolicitacaoCirurgiaApi.getSurgerySolicitationStatusesById(this.surgerySolicitationId)

      if (APIResponse.success) {
        if (APIResponse && APIResponse.data) {
          this.clinicaStatuses = APIResponse.data.map((item: any) => ({
            display: item.display,
            key: item.key,
            disabled: item.disabled || false,
          }))
        }
      } else {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: APIResponse.message || 'Houve um erro ao consultar status da solicitação',
          icon: 'warning',
          color: '#C62828',
          timeout: 7500,
        })
      }
    } catch (error) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Houve um erro ao consultar status da solicitação',
        icon: 'warning',
        color: '#C62828',
        timeout: 7500,
      })
    }
  }

  async createSolicitacaoAPartirDoOrcamentoParticularAvulso(data: AgendamentoMedico) {
    this.loadingCriarSolicitacaoOrcamentoParticularAvulso = true

    const orcamentoData = (await SolicitacaoCirurgiaApi.get(data.id)).data

    // Create solicitacao data
    const { paciente } = orcamentoData

    // eslint-disable-next-line
    if (this.getSolicitacaoCirurgiaStore.template.formulario && this.getSolicitacaoCirurgiaStore.template.formulario.convenio && !this.getSolicitacaoCirurgiaStore.template.formulario.convenio.habilitadoOrcamentoParticularAvulso) {
      paciente.convenioId = undefined
    }

    const { medicoSolicitanteId } = orcamentoData
    const medicoSolicitanteNome = orcamentoData.medicoSolicitante.nome
    const { hospitalId } = orcamentoData

    const modeloCirurgiaId = orcamentoData.id

    // eslint-disable-next-line default-case
    switch (paciente.sexo) {
      case 'Masculino':
        paciente.sexo = 'M'
        break

      case 'Feminino':
        paciente.sexo = 'F'
        break
    }

    const solicitacaoData = {
      paciente,
      hospitalId,
      medicoSolicitanteId,
      modeloCirurgiaId,
    }

    const res = await SolicitacaoCirurgiaApi.post(medicoSolicitanteId, solicitacaoData)

    if (res.success) {
      const solicitacaoId = res.data

      const route = {
        name: 'SolicitacaoCirurgia',
        view: 'solicitacao-cirurgia',
        path: '/solicitacao-cirurgia/:solicitacaoId?/:hospitalId?/:medicoId?/:medico?',
        params: {
          hospitalId,
          medicoId: medicoSolicitanteId,
          medico: medicoSolicitanteNome,
          solicitacaoId,
        },
      }

      this.getSolicitacaoStore.setShowModalGerenciar(false)
      this.$router.push(route).catch(() => { })
    } else {
      EventBus.$emit(
        'setSnackbar',
        { show: true, text: 'Houve um erro ao criar a solicitação a partir do orçamento.', icon: 'warning', color: '#C62828' },
      )
    }

    this.loadingCriarSolicitacaoOrcamentoParticularAvulso = false
  }

  async downloadLatestOrcamentoAvulsoParticular() {
    const data = this.getSolicitacaoPendenciaStore.agendamentoMedico
    await this.getSolicitacaoStore.getOrcamentoAnexo(data.id)

    if (this.getSolicitacaoStore.orcamentoAnexo.length === 0) {
      EventBus.$emit(
        'setSnackbar',
        { show: true, text: 'Não foi encontrado o arquivo de orçamento, entre em contato com o suporte.', icon: 'warning', color: '#C62828' },
      )
    } else {
      const latest = this.getSolicitacaoStore.orcamentoAnexo[0]
      const link = document.createElement('a')
      link.target = '_blank'
      link.href = latest.url
      link.click()
    }
  }

  get canShowCriarSolicitaçãoAPartirDoOrcamentoParticularAvulso() {
    const data = this.getSolicitacaoPendenciaStore.agendamentoMedico
    if (!['Incompleta', 'PreviaCirurgica', 'DisponivelParaEnvio'].includes(data.situacao.key) && data.situacao.key === 'OrcamentoParticularAvulsoEnviado') {
      return true
    }

    return false
  }

  get canShowVisualizarOrcamentoParticularAvulsoAnexo() {
    const data = this.getSolicitacaoPendenciaStore.agendamentoMedico
    return data.situacao.key === 'OrcamentoParticularAvulsoEnviado'
  }

  getChatInfo() {
    const data = this.getSolicitacaoPendenciaStore.agendamentoMedico
    const { solicitacaoChatFinalizado, solicitacaoChatTotalMensagensNaoLidas } = data

    if (solicitacaoChatFinalizado === false) {
      if (solicitacaoChatTotalMensagensNaoLidas! > 0) {
        const number = solicitacaoChatTotalMensagensNaoLidas! >= 1 ? solicitacaoChatTotalMensagensNaoLidas : ''
        const text = solicitacaoChatTotalMensagensNaoLidas! > 1 ? 'Novas Mensagens' : 'Nova Mensagem'

        return { icon: 'chat', title: `${number} ${text}`, class: '-orange' }
      }

      return { icon: 'chat_bubble', title: 'Chat Aberto', class: '-yellow' }
    }

    return { icon: 'chat_bubble_outline', title: 'Nenhum Chat', class: '-gray' }
  }

  get canShowChatButton() {
    const data = this.getSolicitacaoPendenciaStore.agendamentoMedico
    if (!['Incompleta', 'PreviaCirurgica', 'DisponivelParaEnvio', 'Cancelada'].includes(data.situacao.key) && data.hospitalUtilizaChat) {
      return true
    }

    return false
  }

  get chatStore() {
    return getModule(ChatAgendamentoStore, this.$store)
  }

  get chatPendenciaStore() {
    return getModule(ChatAgendamentoPendenciaStore, this.$store)
  }

  get historicoSolicitacaoStore() {
    return getModule(HistoricoSolicitacaoStore, this.$store)
  }

  get backofficeFidelizationStore() {
    return getModule(BackofficeFidelizacaoStore, this.$store)
  }

  get nomeCirurgia() {
    return this.getSolicitacaoPendenciaStore.nomeCirurgia
  }

  set nomeCirurgia(value: string) {
    this.getSolicitacaoPendenciaStore.setNomeCirurgia(value)
  }

  get templateDialog() {
    return this.tmpDialog
  }

  set templateDialog(value: boolean) {
    this.tmpDialog = value
  }

  get podeEditarSolicitacao() {
    return this.getSolicitacaoPendenciaStore.agendamentoMedico.acoes.editar
  }

  get approvalModal() {
    return this.modalApproval
  }

  set approvalModal(value: boolean) {
    this.modalApproval = value
  }

  openModalAprova() {
    this.approvalModal = true
  }

  closeModalAprova() {
    this.approvalModal = false
  }

  openTemplate() {
    this.$refs.nomeCirurgia.$refs.input.value = ''
    this.getSolicitacaoPendenciaStore.clearNomeCirurgia()
    this.nomeCirurgia = this.getSolicitacaoPendenciaStore.agendamentoMedico.procedimento || ''
    this.templateDialog = true
  }

  closeTemplate() {
    this.templateMessage = {
      icon: 'mdi-help-circle-outline',
      message: 'Gostaria de salvar esta solicitação como modelo?',
      color: 'blue darken-4',
    }

    this.getSolicitacaoPendenciaStore.clearNomeCirurgia()
    this.$refs.nomeCirurgia.$refs.input.value = ''
    this.templateDialog = false
  }

  get placeHolder() {
    return this.place
  }

  set placeHolder(value: string) {
    this.place = value
  }

  get localLoading() {
    return this.localLoad
  }

  set localLoading(value: boolean) {
    this.localLoad = value
  }

  get locaisAtendimento() {
    return this.getSolicitacaoPendenciaStore.locaisAtendimento
      ? this.getSolicitacaoPendenciaStore.locaisAtendimento.filter((e: any) => e.ativo)
      : []
  }

  get locaisAtendimentoInactive() {
    return this.getSolicitacaoPendenciaStore.locaisAtendimento
      ? this.getSolicitacaoPendenciaStore.locaisAtendimento.filter((e: any) => !e.ativo)
      : []
  }

  get localAtendimentoId() {
    if (this.getSolicitacaoPendenciaStore.agendamentoMedico.localAtendimentoId) {
      const localId = this.getSolicitacaoPendenciaStore.agendamentoMedico.localAtendimentoId
      const local = this.getSolicitacaoPendenciaStore.locaisAtendimento.find((e: any) => e.id === localId)
      if (local && !local.ativo) this.placeHolder = local.nome
      return this.getSolicitacaoPendenciaStore.localAtendimentoId
    }
    return ''
  }

  set localAtendimentoId(value: string | null) {
    this.getSolicitacaoPendenciaStore.setLocalAtendimentoId(value)
  }

  get loadingClose() {
    return this.loadClose
  }

  set loadingClose(value: boolean) {
    this.loadClose = value
  }

  confirm: boolean = false
  cancel: boolean = false
  tipoUsuario: string = TipoUsuarioEnum.Medico
  dataAgendamento: string = ''
  loadTemplate: boolean = false
  tmpMessage: any = {
    icon: 'mdi-help-circle-outline',
    message: 'Gostaria de salvar esta solicitação como modelo?',
    color: 'blue darken-4',
  }

  closeModalCancelamento(solicitacao: Solicitacao) {
    this.closeModalGerenciar()
  }

  get templateMessage() {
    return this.tmpMessage
  }

  set templateMessage(value: any) {
    this.tmpMessage = value
  }

  get loadingTemplate() {
    return this.loadTemplate
  }

  set loadingTemplate(value: boolean) {
    this.loadTemplate = value
  }

  get filterCirurgias() {
    return this.getSolicitacaoStore.filterCirurgias
  }

  get getSolicitacaoStore() {
    return getModule(SolicitacaoStore, this.$store)
  }

  get getSolicitacaoCirurgiaStore() {
    return getModule(SolicitacaoCirurgiaStore, this.$store)
  }

  get getSolicitacaoPendenciaStore() {
    return getModule(SolicitacaoPendenciaStore, this.$store)
  }

  get getContestacaoMedicaStore() {
    return getModule(ContestacaoMedicaStore, this.$store)
  }

  get getSolicitacaoCancelamentoStore() {
    return getModule(SolicitacaoCancelamentoStore, this.$store)
  }

  get getChatStore() {
    return getModule(ChatStore, this.$store)
  }

  get showModalGerenciar() {
    return this.getSolicitacaoStore.modalSolicitacaoCirurgia.showGerenciar
  }

  set showModalGerenciar(value: boolean) {
    this.getSolicitacaoStore.setShowModalGerenciar(value)
  }

  get getTheme() {
    return Theme
  }

  async salvarComoModelo() {
    this.loadingTemplate = true

    const params: any = {
      solicitacaoId: this.getSolicitacaoPendenciaStore.agendamentoMedico.id,
      nomeCirurgia: this.nomeCirurgia,
    }

    const response = await this.getSolicitacaoPendenciaStore.criarModeloCirurgia(params)
    if (response) {
      this.templateMessage = {
        icon: 'mdi-check-circle-outline',
        message: 'Modelo salvo com sucesso!',
        color: 'green darken-3',
      }
      this.ga('agendamento-medico', 'salvar-cirurgia-como-modelo')
      await timeout(2500)
      this.closeTemplate()
    } else {
      this.templateMessage = {
        icon: 'mdi-close-circle-outline',
        message: 'Ocorreu um erro ao salvar o modelo...',
        color: 'red darken-2',
      }
    }
    this.loadingTemplate = false
  }

  isInactive(localAtendimentoId: string | null) {
    if (localAtendimentoId === null) return false
    return this.locaisAtendimentoInactive.some((e: any) => e.id === localAtendimentoId)
  }

  getLocalAtendimentoNome(localAtendimentoId: string | null) {
    let localNome = ''
    if (localAtendimentoId && this.locaisAtendimentoInactive && this.locaisAtendimentoInactive.length > 0) {
      const found = this.locaisAtendimentoInactive.find((e: any) => e.id === localAtendimentoId)
      localNome = found ? found.nome : ''
    }
    return localNome
  }

  async atualizaLocal(e: string) {
    this.localLoading = true
    const response = await this.getSolicitacaoPendenciaStore.atualizaLocalAtendimento(e)
    if (response) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Origem do paciente atualizado com sucesso!', icon: 'done', color: '#2E7D32' })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: 'Não foi possível atualizar a origem do paciente', icon: 'warning', color: '#C62828' })
    }
    this.localLoading = false
  }

  async showModalAlteracaoDataAgendamento(solicitacaoId: string) {
    if (this.getSolicitacaoPendenciaStore.agendamentoMedico.dataAutorizada
      && this.getSolicitacaoPendenciaStore.agendamentoMedico.dataAutorizada.data) {
      this.getDataAgendamento = `${this.getSolicitacaoPendenciaStore.agendamentoMedico.dataAutorizada.data} ${this.getSolicitacaoPendenciaStore.agendamentoMedico.dataAutorizada.hora} `
    }

    await this.getChatStore.getDataAgendamento(solicitacaoId)
    this.getSolicitacaoStore.setShowAlteracaoDataAgendamento(true)
  }

  async showModalAlteracaoDataAgendamentoClinica(solicitacaoId: string) {
    if (this.getSolicitacaoPendenciaStore.agendamentoMedico.dataAutorizada
      && this.getSolicitacaoPendenciaStore.agendamentoMedico.dataAutorizada.data) {
      this.getDataAgendamento = `${this.getSolicitacaoPendenciaStore.agendamentoMedico.dataAutorizada.data} ${this.getSolicitacaoPendenciaStore.agendamentoMedico.dataAutorizada.hora} `
    }

    await this.getChatStore.getDataAgendamento(solicitacaoId)
    this.getSolicitacaoStore.setShowAlteracaoDataAgendamentoClinica(true)
  }

  async showModalAprovarOuRecusarOrcamento(solicitacaoId: string) {
    const { hospitalId } = this.getSolicitacaoPendenciaStore.agendamentoMedico
    await this.getSolicitacaoStore.getOrcamentoAnexo(solicitacaoId)
    if (this.hospitalInformaMotivoDeRecusaDoOrcamento) await this.getSolicitacaoPendenciaStore.getMotivoDeRecusaDoOrcamentoByHospitalId(hospitalId)
    this.getSolicitacaoPendenciaStore.setModalAprovarOuRecusarOrcamento(true)
  }

  get currentUserHospitals() {
    return this.getSolicitacaoStore.currentUserHospitals
  }

  get hospitalInformaMotivoDeRecusaDoOrcamento() {
    const { hospitalId } = this.getSolicitacaoPendenciaStore.agendamentoMedico
    const hospital = this.currentUserHospitals.find((h: any) => h.id === hospitalId) || { hospitalInformaMotivoDeRecusaDoOrcamento: false }
    return !!hospital.hospitalInformaMotivoDeRecusaDoOrcamento
  }

  get getDataAgendamento() {
    return this.dataAgendamento
  }

  set getDataAgendamento(value: string) {
    this.dataAgendamento = value
  }

  getOpmes() {
    const { solicitacaoId } = this.getSolicitacaoPendenciaStore.pendencia
    this.getSolicitacaoStore.setSolicitacaoId(solicitacaoId)
    return this.getSolicitacaoStore.LoadOpmes()
  }

  async getUser() {
    return this.$user
  }

  async responderContestacao() {
    this.setLoadingRequest(true, this.getSolicitacaoStore.requestMessage.avancar.text)
    const request = await this.getContestacaoMedicaStore.getContestacaoMedica(this.getSolicitacaoPendenciaStore.pendencia.solicitacaoId)
    if (request.success) {
      this.getContestacaoMedicaStore.setShowModalContestacaoMedica(true)
    } else {
      this.snackBarMessageError('Houve um problema ao abrir/verificar contestação.')
    }
    this.clearLoadingRequest()
  }

  async abrirChatPendenciaOld() {
    const enviar = TipoEnvioMensagemEnum.Enviar

    this.getSolicitacaoPendenciaStore.setAcessoHospital(false)
    const { solicitacaoId } = this.getSolicitacaoPendenciaStore.pendencia
    await this.getSolicitacaoPendenciaStore.getPendencias(solicitacaoId)
    this.getSolicitacaoPendenciaStore.setTipoEnvioMensagem(enviar)
    this.getSolicitacaoPendenciaStore.setModalSolicitacaoPendencia(true)
  }

  async abrirChatPendencia() {
    // this.abrirChatPendenciaOld()
    const data = this.getSolicitacaoPendenciaStore.agendamentoMedico
    const solicitationId = data.id

    this.loadingChat = solicitationId

    const recipientName = data.hospital
    const senderId = this.$user.profile.sub

    this.chatPendenciaStore.reset()
    this.chatPendenciaStore.openChatModal({
      solicitationId,
      recipientName,
      senderId,
    })

    this.ga('agendamento-medico', 'abrir-chat-pendencia')

    this.loadingChat = ''
  }

  async visualizar() {
    const { agendamentoMedico } = this.getSolicitacaoPendenciaStore

    const budgetMode = agendamentoMedico.acoes.podeUsarOrcamentoParticularAvulsoComoSolicitacaoModelo

    const route = {
      name: 'SolicitacaoCirurgiaDetails',
      view: 'solicitacao-cirurgia',
      path: '/solicitacao-cirurgia-details/:solicitacaoId/:hospitalId/:medicoId/:medico',
      params: {
        hospitalId: agendamentoMedico.hospitalId,
        medicoId: agendamentoMedico.medicoSolicitanteId,
        medico: agendamentoMedico.nomeMedico,
        solicitacaoId: agendamentoMedico.id,
      },
      query: {},
    }

    if (budgetMode) {
      const query = route.query as any
      query.budgetMode = 'true'
    }

    this.ga('agendamento-medico', 'detalhes-solicitacao')
    this.getSolicitacaoStore.setShowModalGerenciar(false)
    this.$router.push(route).catch(() => {})
  }

  async editar() {
    const { agendamentoMedico } = this.getSolicitacaoPendenciaStore

    const route = {
      name: 'SolicitacaoCirurgia',
      view: 'solicitacao-cirurgia',
      path: '/solicitacao-cirurgia/:solicitacaoId?/:hospitalId?/:medicoId?/:medico?',
      params: {
        hospitalId: agendamentoMedico.hospitalId,
        medicoId: agendamentoMedico.medicoSolicitanteId,
        medico: agendamentoMedico.nomeMedico,
        solicitacaoId: agendamentoMedico.id,
      },
    }

    this.ga('agendamento-medico', 'editar-solicitacao')
    this.getSolicitacaoStore.setShowModalGerenciar(false)
    this.$router.push(route).catch(() => {})
  }

  snackBarMessageError(message) {
    this.snackbar.message = message
    this.snackbar.show = true
    this.getSolicitacaoStore.setSnackbar(this.snackbar)
  }

  checkItensAutorizados(value) {
    return (value && value.situacao)
      ? ['AutorizadaParcial', 'Autorizada', 'Cancelada', 'Cancelado', 'ContestacaoMedica', 'CancelamentoSolicitado'].includes(value.situacao.key)
      : false
  }

  checkCancelamento(value) {
    return (value)
      ? !['Incompleta', 'Cancelada', 'Cancelado', 'CancelamentoSolicitado'].includes(value)
      : false
  }

  async itensAutorizados() {
    const { solicitacaoId } = this.getSolicitacaoPendenciaStore.pendencia
    const { status, init } = this.getSolicitacaoStore.requestMessage
    this.setLoadingRequest(status, init.text)
    await this.getSolicitacaoStore.showModalItensAutorizados(solicitacaoId)
    this.ga('agendamento-medico', 'ver-itens-autorizados')
    this.clearLoadingRequest()
  }

  async itensAutorizadosClinica() {
    const { solicitacaoId } = this.getSolicitacaoPendenciaStore.pendencia
    const { status, init } = this.getSolicitacaoStore.requestMessage
    this.setLoadingRequest(status, init.text)
    await this.getSolicitacaoStore.showModalItensAutorizadosClinica(solicitacaoId)
    this.ga('agendamento-medico', 'ver-itens-autorizados-clinica')
    this.clearLoadingRequest()
  }

  async marcarCirurgiaComoRealizada() {
    const { status, init } = this.getSolicitacaoStore.requestMessage
    this.setLoadingRequest(status, init.text)

    const solicitacaoId = this.getSolicitacaoPendenciaStore.agendamentoMedico.id

    const res = await this.solicitacaoClinicaStore.marcarCirurgiaComoRealizada(solicitacaoId)

    if (res.success) {
      this.closeModalGerenciar()

      EventBus.$emit('setSnackbar', { show: true, text: 'Solicitação marcada como realizada.', icon: 'done', color: '#2E7D32' })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: res.message || 'Houve um erro ao marcar a solicitação como realizada.', icon: 'warning', color: '#C62828' })
    }

    this.clearLoadingRequest()


    this.ga('agendamento-medico', 'marcar-cirurgia-como-realizada-clinica')
  }

  async desmarcarCirurgiaComoRealizada() {
    const { status, init } = this.getSolicitacaoStore.requestMessage
    this.setLoadingRequest(status, init.text)

    const solicitacaoId = this.getSolicitacaoPendenciaStore.agendamentoMedico.id

    const res = await this.solicitacaoClinicaStore.desmarcarCirurgiaComoRealizada(solicitacaoId)

    if (res.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Solicitação marcada como não realizada.', icon: 'done', color: '#2E7D32' })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: 'Houve um erro ao marcar a solicitação como não realizada.', icon: 'warning', color: '#C62828' })
    }

    this.clearLoadingRequest()

    this.closeModalGerenciar()

    this.ga('agendamento-medico', 'marcar-cirurgia-como-nao-realizada-clinica')
  }

  async motivoCancelamento() {
    const { solicitacaoId } = this.getSolicitacaoPendenciaStore.pendencia
    const { status, init } = this.getSolicitacaoStore.requestMessage
    this.setLoadingRequest(status, init.text)
    await this.getSolicitacaoStore.showModalMotivoCancelamento(solicitacaoId)
    this.ga('agendamento-medico', 'ver-motivo-cancelamento')
    this.clearLoadingRequest()
  }

  reasonProtocolRejection = ''

  async openProtocolPendencyModal() {
    this.setLoadingRequest(true, 'Carregando...')

    const { solicitacaoId: surgerySolicicationId } = this.getSolicitacaoPendenciaStore.pendencia
    const { hospitalId } = this.getSolicitacaoStore.solicitacao

    this.getSolicitacaoCirurgiaStore.setLocaisAtendimento(this.getSolicitacaoPendenciaStore.locaisAtendimento)

    await this.getSolicitacaoCirurgiaStore.getTemplateHospital(hospitalId)
    await this.getSolicitacaoCirurgiaStore.getSolicitacaoById(surgerySolicicationId)

    const { solicitacaoCirurgia: surgerySolicicationData } = this.getSolicitacaoCirurgiaStore

    if (surgerySolicicationData && surgerySolicicationData.protocoloDeCirurgia) {
      const { justificativaMedico: doctorReasonProtocolRejection } = surgerySolicicationData.protocoloDeCirurgia

      if (doctorReasonProtocolRejection) {
        const { texto: doctorReasonProtocolRejectionDescription } = doctorReasonProtocolRejection

        this.reasonProtocolRejection = doctorReasonProtocolRejectionDescription || ''
      }
    }

    await this.getSolicitacaoStore.setShowModalPendenciaProtocolo(true)

    this.clearLoadingRequest()
  }

  async cancelamento() {
    const cancelarSolicitacaoParam: CancelarSolicitacaoParam = {
      solicitacaoId: this.getSolicitacaoPendenciaStore.pendencia.solicitacaoId,
      tipoOrigem: TipoOrigemEnum.Undefined,
      canceladoMotivo: {
        display: '',
        key: '',
      },
      situacao: {
        display: '',
        key: '',
      },
      modal: '',
    }

    this.getSolicitacaoCancelamentoStore.setCancelarSolicitacaoParam(cancelarSolicitacaoParam)
    this.getSolicitacaoCancelamentoStore.setShowModalCancelamentoMedico(true)
    await this.getSolicitacaoCancelamentoStore.getMotivosCancelamentoAll({ hospitalId: this.getSolicitacaoPendenciaStore.agendamentoMedico.hospitalId })
  }

  async assinarEEnviar() {
    this.setLoadingRequest(true, 'Aguardando o envio')
    const response = await this.getSolicitacaoStore.finalizarDisponivelParaEnvio(this.getSolicitacaoPendenciaStore.agendamentoMedico.id)
    if (!response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Ocorreu um erro na requisição', icon: 'warning', color: '#C62828' })
      this.clearLoadingRequest()
      return
    }
    EventBus.$emit('setSnackbar', { show: true, text: 'Solicitação enviada com sucesso!', icon: 'done', color: '#2E7D32' })
    this.clearLoadingRequest()
    this.closeModalGerenciar()
  }

  closeModalPendencia() {
    this.LoadAgendamentosMedico()
  }

  async apagarSolicitacao() {
    this.loadingDeleteSolicitacao = true
    const response = await this.getSolicitacaoPendenciaStore.deleteSolicitacao(this.getSolicitacaoPendenciaStore.agendamentoMedico.id)
    if (!response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Ocorreu um erro na requisição', icon: 'warning', color: '#C62828' })
      this.loadingDeleteSolicitacao = false
      return
    }
    await this.closeModalGerenciar()
    EventBus.$emit('setSnackbar', { show: true, text: 'Solicitação apagada com sucesso!', icon: 'done', color: '#2E7D32' })
    this.loadingDeleteSolicitacao = false
  }

  async aplicarModelo(agendamentoMedico: any) {
    this.setLoadingRequest(true, 'Carregando...')
    const request = await this.getSolicitacaoPendenciaStore.getModeloCirurgia({
      hospitalId: agendamentoMedico.hospitalId,
      medicoId: agendamentoMedico.medicoSolicitanteId,
      convenioId: agendamentoMedico.convenioId,
      planoId: agendamentoMedico.planoId,
      localAtendimentoId: this.localAtendimentoId,
    })

    if (request.success) {
      this.getSolicitacaoPendenciaStore.setShowModalAplicarModeloCirurgia(true)
      this.ga('agendamento-medico', 'aplicar-modelo-pre-reserva')
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: request.message || 'Ocorreu um erro na requisição', icon: 'warning', color: '#C62828' })
    }
    this.clearLoadingRequest()
  }

  get hasPedidoSemAssinatura() {
    const { agendamentoMedico } = this.getSolicitacaoPendenciaStore
    const laudos = agendamentoMedico.laudos || []
    return !!laudos.length && laudos.some((laudo: any) => laudo.tipoDocumento === TipoDocumentoUpload.PedidoMedicoSemAssinatura)
  }

  getPedidoMedicoSemAssinaturaUrl(agendamentoMedico: AgendamentoMedico) {
    const laudos = agendamentoMedico.laudos || []
    if (laudos.some((laudo: any) => laudo.tipoDocumento === TipoDocumentoUpload.PedidoMedicoSemAssinatura)) {
      const laudo = laudos.find((l: any) => l.tipoDocumento === TipoDocumentoUpload.PedidoMedicoSemAssinatura)
      return laudo ? laudo.url : ''
    }
    return ''
  }

  async gerarPedidoSemAssinatura() {
    this.setLoadingRequest(true, 'Gerando pedido...')
    const response = await this.getSolicitacaoPendenciaStore.gerarPedidoSemAssinatura()
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Pedido gerado com sucesso! Atualize a página para visualizar o seu documento.', icon: 'done', color: '#2E7D32', timeout: 6000 })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Não foi possivel gerar o pedido sem assinatura', icon: 'warning', color: '#C62828' })
    }
    this.clearLoadingRequest()
  }

  TISSPDFFileURL(documentSlug: 'GuiaTissInternacao' | 'GuiaTissOpme'): string {
    const documentData = this.getSolicitacaoPendenciaStore.agendamentoMedico.laudos
      .find((laudo: any) => laudo.tipoDocumento === TipoDocumentoUpload[documentSlug])

    return documentData ? documentData.url : ''
  }

  get useHasReadonlyTISSPDFPermission() {
    return permissionService.hasPermission('agendamento.medica.guiaTiss.visualizar') || this.hospitalHasGenerateAndPrintTISSPDFPermission
  }

  get useHasGenerateTISSPDFPermission() {
    return permissionService.hasPermission('agendamento.medica.guiaTiss.gerar') || this.hospitalHasGenerateAndPrintTISSPDFPermission
  }

  get hospitalHasGenerateAndPrintTISSPDFPermission() {
    return !!this.getSolicitacaoPendenciaStore.agendamentoMedico.acoes.permiteVisualizacaoGuiaTissNaVisaoClinica
  }

  get surgerySolicitationHasOpme() {
    return this.getSolicitacaoPendenciaStore.agendamentoMedico.temOpme
  }

  TISSPDFInfo(documentSlug: 'GuiaTissInternacao' | 'GuiaTissOpme'): {
    documentName: string,
    documentType: TipoDocumentoUpload,
    documentPageOrientation: 'portrait' | 'landscape',
    documentRef: any
  } {
    switch (documentSlug) {
      case 'GuiaTissInternacao':
        return {
          documentName: 'Guia TISS de Internação',
          documentType: TipoDocumentoUpload.GuiaTissInternacao,
          documentPageOrientation: 'portrait',
          documentRef: this.$refs.guiaTissInternacao,
        }
      case 'GuiaTissOpme':
        return {
          documentName: 'Guia TISS de OPME',
          documentType: TipoDocumentoUpload.GuiaTissOpme,
          documentPageOrientation: 'landscape',
          documentRef: this.$refs.guiaTissOpme,
        }
      default:
        return {
          documentName: 'Guia TISS de Internação',
          documentType: TipoDocumentoUpload.GuiaTissInternacao,
          documentPageOrientation: 'portrait',
          documentRef: this.$refs.guiaTissInternacao,
        }
    }
  }

  async createTISSPDF(documentSlug: 'GuiaTissInternacao' | 'GuiaTissOpme') {
    try {
      this.setLoadingRequest(true, 'Carregando...')

      const TISSPDFInfo = this.TISSPDFInfo(documentSlug)

      const APIResponseTISSInformationInfo = await this.getBackofficeGlobalStore.getAllInformacoesParaGerarAGuiaTiss({
        solicitacaoId: this.getSolicitacaoPendenciaStore.pendencia.solicitacaoId,
        tipoDoTemplate: TISSPDFInfo.documentType,
      })

      if (APIResponseTISSInformationInfo.success) {
        this.$forceUpdate()

        const TISSDefaultPDFFile = await createPDFWithMultiplePagesGeneration(
          TISSPDFInfo.documentName,
          TISSPDFInfo.documentRef,
          TISSPDFInfo.documentPageOrientation,
        )

        await this.uploadTISSFile({
          file: TISSDefaultPDFFile,
          documentType: TISSPDFInfo.documentType,
        })

        EventBus.$emit('setSnackbar', {
          show: true,
          text: `${TISSPDFInfo.documentName} gerada com sucesso`,
          icon: 'done',
          color: '#2E7D32',
        })
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: APIResponseTISSInformationInfo.message || 'Erro ao buscar informações para geração da guia TISS', icon: 'warning', color: '#C62828' })
      }
    } catch (error) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Erro ao gerar guia TISS', icon: 'warning', color: '#C62828' })
    } finally {
      this.clearLoadingRequest()
      this.getBackofficeGlobalStore.clearGuiaTissInternacaoOpme()
    }
  }

  async uploadTISSFile({ file, documentType }: { file: File, documentType: TipoDocumentoUpload }) {
    try {
      const { hospitalId } = this.getSolicitacaoPendenciaStore.agendamentoMedico

      const attachmentTISSPDFFormData = new FormData()
      attachmentTISSPDFFormData.append('laudos', file)

      const APIResponseUploadTISSPDF = await this.getBackofficeGlobalStore.upload({
        solicitacaoId: this.getSolicitacaoPendenciaStore.pendencia.solicitacaoId,
        formData: attachmentTISSPDFFormData,
        tipoDocumento: documentType,
      })
      const fileUploadSuccessfully = !((APIResponseUploadTISSPDF.data && APIResponseUploadTISSPDF.data.length === 0) || !APIResponseUploadTISSPDF.data)

      if (fileUploadSuccessfully) {
        const surgerySolicicationAttachments = this.getSolicitacaoPendenciaStore.agendamentoMedico.laudos
          .filter(document => document.tipoDocumento === TipoDocumentoUpload[documentType])

        await Promise.all(
          surgerySolicicationAttachments.map((document: any) => this.getBackofficeGlobalStore.deleteLaudo({
            hospitalId,
            id: document.id,
          })),
        )

        await this.getBackofficeGlobalStore.gerarResumo(this.getSolicitacaoPendenciaStore.pendencia.solicitacaoId)

        this.getSolicitacaoPendenciaStore.agendamentoMedico.laudos = this.getSolicitacaoPendenciaStore.agendamentoMedico.laudos.filter(
          document => !surgerySolicicationAttachments.some(d => d.id === document.id),
        )

        this.getSolicitacaoPendenciaStore.agendamentoMedico.laudos.push({
          tipoDocumento: documentType,
          url: APIResponseUploadTISSPDF.data[0].url,
          id: APIResponseUploadTISSPDF.data[0].id,
          identifier: '',
          name: '',
          createdBy: '',
          createdByName: '',
          createdOn: '',
          nomeArquivo: APIResponseUploadTISSPDF.data[0].nomeOriginalArquivo,
          nomeOriginalArquivo: APIResponseUploadTISSPDF.data[0].nomeOriginalArquivo,
        })
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: APIResponseUploadTISSPDF.message || 'Erro ao salvar arquivo', icon: 'warning', color: '#C62828' })
      }
    } catch (error) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Erro ao salvar arquivo', icon: 'warning', color: '#C62828' })
    }
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  async closeModalGerenciar() {
    this.loadingClose = true
    this.getSolicitacaoStore.clearSolicitacao()
    this.getSolicitacaoPendenciaStore.clearLocalAtendimentoId()
    this.getSolicitacaoPendenciaStore.clearLocaisAtendimento()
    this.getSolicitacaoPendenciaStore.clearLocalAtendimento()
    this.LoadAgendamentosMedico()

    if (!this.getSolicitacaoStore.isInstrumentador) {
      await this.getSolicitacaoStore.LoadHospitais(this.$user.profile.sub)
    }

    this.confirmarExclusao = false
    this.getSolicitacaoStore.setShowModalGerenciar(false)
    this.loadingClose = false
  }

  openSurgeryAnnotationModal(delay = 0) {
    setTimeout(() => {
      if (this.podeVisualizarAnotacoes) {
        this.isSurgeryAnnotationModalOpen = true
      }
    }, delay)
  }

  closeSurgeryAnnotationModal() {
    this.isSurgeryAnnotationModalOpen = false
  }

  handleSurgeryAnnotationsLoading(isLoading: boolean) {
    this.loadingSurgeryAnnotations = isLoading
  }

  maskMoneyUtil(value: any) {
    return maskMoney(value)
  }

  ga(event: string, action: string) {
    this.$ga.event(event, action, this.$user.profile.email)
  }

  refreshSolicitacao() {
    this.$emit('loadAgendamentosMedico')
  }

  @Watch('showModalGerenciar')
  onShowModalGerenciarChange(newValue: boolean) {
    if (newValue) {
      this.aprovacaoData()
    }
  }

  get surgerySolicitationId() {
    return this.getSolicitacaoPendenciaStore.agendamentoMedico.id
  }


  @Emit('loadAgendamentosMedico')
  LoadAgendamentosMedico() {}

  @Emit('setLoadingRequest')
  setLoadingRequest(status, text) { }

  @Emit('clearLoadingRequest')
  clearLoadingRequest() { }
}
